<template>
    <div>

        <main role="main">

            <div class="container-fluid">


                <div class="row mt-2 mb-2">

                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <h2 class="mb-5">
                            <font-awesome-icon icon="home"/>
                            {{$t('text.apmPages.apmLabel')}}
                        </h2>

                        <div class="row mt-3 mb-3">

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      formatted="DD.MM.YYYY, HH:mm"
                                                      v-model="startTimestamp"
                                                      @input="updateTimes()"
                                                      :noClearButton="true"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="endTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      formatted="DD.MM.YYYY, HH:mm" v-model="endTimestamp"
                                                      @input="updateTimes()"
                                                      :noClearButton="true"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-12">
                                <vue-good-table
                                        styleClass="vgt-table table table-hover table-striped"
                                        :columns="columns"
                                        :rows="rows"

                                >
                                    <div slot="emptystate">
                                        <div class="text-center"><i class="fa fa-exclamation-triangle"></i> <em>{{$t('text.globals.noData')}}</em></div>
                                    </div>
                                    <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'serviceName'">
                                                <a href="javascript:void(0)" @click.st=onRowClick(props.row.serviceName)>{{props.row.serviceName}}</a>
                                            </span>
                                    </template>
                                </vue-good-table>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);

    export default {
        name: 'APM',
        components: {
            SidebarNavigation,
            VueGoodTable
        },
        data() {
            return {
                //date and time
                startTimestamp: null,
                endTimestamp: null,
                startTimeDate: null,
                endTimeDate: null,
                //table
                columns: [
                    {
                        label: this.$t('text.apmPages.tableColumns.serviceName'),
                        field: 'serviceName',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.agentName'),
                        field: 'agentName',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.avgResponseTime'),
                        field: 'avgResponseTime',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatMiliseconds,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.transactionsPerMinute'),
                        field: 'transactionsPerMinute',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatTransactionsPerMinute,
                    },
                    {
                        label:  this.$t('text.apmPages.tableColumns.errorsPerMinute'),
                        field: 'errorsPerMinute',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatErrorsPerMinute,
                    }
                ],
                rows: [],
                breadcrumbItems: [
                    {
                        text: this.$t('text.apmPages.apmLabel'),
                        href: '#/apm/',
                    },
                    {
                        text: this.$t('text.apmPages.services'),
                        active: true
                    }
                ]
            }
        },
        mounted() {
            this.initDate();
        },

        watch: {
            '$route'(to, from) {
                // react to route changes...

                this.initDate();


            }

        },

        methods: {


            updateTimes(){

                this.$router.push({
                    path: "",
                    query:{
                        start: encodeURIComponent(this.startTimestamp),
                        end: encodeURIComponent(this.endTimestamp)
                    }
                });


            },


            getData() {


                axios.get(config.kibana + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + '&uiFilters=%7B%7D', {headers: {}})
                    .then((res) => {
                        console.log("response:", res.data);
                        this.rows = null;
                        this.rows = res.data.items;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            onRowClick(serviceName) {
                // params.row - row object
                // params.pageIndex - index of this row on the current page.
                // params.selected - if selection is enabled this argument
                // indicates selected or not
                // params.event - click event

                this.$router.push('/transactions/' + serviceName  + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));

            },

            initDate() {
                const _this = this;

                if (this.$route.query.start == null && this.$route.query.end == null) {
                    this.endTimeDate = _this.moment().seconds(0).milliseconds(0).toDate();
                    this.startTimeDate = _this.moment().seconds(0).milliseconds(0).toDate();

                    this.startTimeDate.setDate(this.endTimeDate.getDate() - 1);
                    this.startTimestamp = this.startTimeDate.toISOString();
                    this.endTimestamp = this.endTimeDate.toISOString();

                    this.$router.push({
                        path: "",
                        query:{
                            start: encodeURIComponent(this.startTimestamp),
                            end: encodeURIComponent(this.endTimestamp)
                        }
                    });

                } else {

                    this.startTimestamp = decodeURIComponent(this.$route.query.start);
                    this.endTimestamp = decodeURIComponent(this.$route.query.end);


                }

                this.breadcrumbItems[0].href = "#/apm/" + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.getData();
            },


            formatMiliseconds(value) {

                if (value === null) {
                    return this.$t('text.apmPages.unavailable');
                } else {
                    return Math.round(value / 1000) + " " +  this.$t('text.apmPages.ms');
                }

            },

            formatTransactionsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " +  this.$t('text.apmPages.tpm');
            },


            formatErrorsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " +  this.$t('text.apmPages.epm');
            },

        },
        beforeCreate: function () {
            document.body.className = 'subpage-one';
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/Apm.vue